import { render, staticRenderFns } from "./ProjectTabReminders.vue?vue&type=template&id=5bf696bd&"
import script from "./ProjectTabReminders.vue?vue&type=script&lang=js&"
export * from "./ProjectTabReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports